export default "__VITE_ASSET__E969Tefp__"